import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';
import { useStaticPermissions } from 'common/auth/Authorize';
import { useFeatureFlags } from 'common/featureFlag/useFeatureFlags';
import { SecondaryNavGroup, SecondaryNavItem } from './SecondaryNavigation.types';
import { isArray } from '@utmost.co/utmost-design-system';
import { isSecondaryNavGroup } from 'common/SecondaryNavigation/utils/guards';

export function useSettingsItemPermissions() {
  const staticPermission = useStaticPermissions();
  const { isEnabled } = useFeatureFlags();
  const darklyOptions = useDarkly();

  return (item: Pick<SecondaryNavItem, 'permissions' | 'featureFlag' | 'useDarkly' | 'reverseDarkly'>): boolean => {
    if (
      item.permissions &&
      !item.permissions.every(
        (permission) => staticPermission({ permissionName: permission.name })[permission.action ?? 'READ']
      )
    ) {
      return false;
    }
    if (item.featureFlag && !isEnabled(item.featureFlag)) {
      return false;
    }
    if (item.useDarkly) {
      if (isArray(item.useDarkly)) {
        return item.useDarkly.every((flag) => (item.reverseDarkly ? !darklyOptions[flag] : darklyOptions[flag]));
      }
      if (item.reverseDarkly) {
        return !darklyOptions[item.useDarkly];
      }
      if (!darklyOptions[item.useDarkly]) {
        return false;
      }
    }
    return true;
  };
}

export const useSecondaryNavigationPermissions = () => {
  const hasItemPermission = useSettingsItemPermissions();

  const hasPermissions = (navElement: SecondaryNavItem | SecondaryNavGroup): boolean => {
    if (isSecondaryNavGroup(navElement)) {
      return navElement.items.some((item) => {
        if (isSecondaryNavGroup(item)) {
          return hasPermissions(item);
        }
        return hasItemPermission(item);
      });
    }
    return hasItemPermission(navElement);
  };

  return hasPermissions;
};
